/* eslint-disable react/jsx-quotes */
/* eslint-disable react/jsx-sort-prop-types */

import Axios from "axios";
import { ID_TOKEN } from "./authutils";
import { AppAPIKey } from "./domain";

const getGrapQLAxiosInstance = () => {
  return Axios.create({
    baseURL: "https://sdk.invoxcontact.io/",
    headers: {
      "x-api-key": AppAPIKey,
      "authorization": `Bearer ${localStorage.getItem(ID_TOKEN)}`,
      "Content-Type": "application/json",
    },
  });
};

export default getGrapQLAxiosInstance;



// WEBPACK FOOTER //
// ./src/utils/graphQLAxios.js